"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UwSpecExecutionMode = exports.UnderwriteMultiSpecsDecisionType = exports.UnderwriteMultiSpecsResultType = exports.ResolutionErrorType = exports.MultiSpecUnderwritingEngineType = void 0;
// ---------------------------------------------------------------------------
// UW Spec resolution and materialization outcomes
// ---------------------------------------------------------------------------
// TODO: This whole file belongs in aven_internal_types, needs to be moved.
/** @TranslateToPython Which underwriting engine(s) should evaluate specs from a config entry. */
var MultiSpecUnderwritingEngineType;
(function (MultiSpecUnderwritingEngineType) {
    MultiSpecUnderwritingEngineType["python"] = "python";
    MultiSpecUnderwritingEngineType["mortgage"] = "mortgage";
})(MultiSpecUnderwritingEngineType || (exports.MultiSpecUnderwritingEngineType = MultiSpecUnderwritingEngineType = {}));
/** @TranslateToPython */
var ResolutionErrorType;
(function (ResolutionErrorType) {
    ResolutionErrorType["basePolicyNotFound"] = "basePolicyNotFound";
    ResolutionErrorType["unknownVariant"] = "unknownVariant";
    ResolutionErrorType["variantBuildFailed"] = "variantBuildFailed";
    ResolutionErrorType["constraintFailed"] = "constraintFailed";
    ResolutionErrorType["unexpectedException"] = "unexpectedException";
})(ResolutionErrorType || (exports.ResolutionErrorType = ResolutionErrorType = {}));
// ---------------------------------------------------------------------------
// Multi-Spec Underwriting Service (/underwrite_multi_specs)
// ---------------------------------------------------------------------------
/**
 * Result type for multispec underwriting evaluation.
 * Indicates whether evaluation produced a decision, hit a missing report, or encountered an error.
 *
 * Used by creditPolicy runners to filter out non-decision results (missing reports, errors)
 * and by PYTHON_UW_ANALYSIS_INFO table for analytics.
 *
 * @TranslateToPython
 */
var UnderwriteMultiSpecsResultType;
(function (UnderwriteMultiSpecsResultType) {
    /** Underwriting produced a decision (approval or denial). */
    UnderwriteMultiSpecsResultType["decision"] = "decision";
    /** Missing required report prevented evaluation. */
    UnderwriteMultiSpecsResultType["missingReport"] = "missingReport";
    /** Error occurred during evaluation. */
    UnderwriteMultiSpecsResultType["error"] = "error";
})(UnderwriteMultiSpecsResultType || (exports.UnderwriteMultiSpecsResultType = UnderwriteMultiSpecsResultType = {}));
/**
 * Decision type when resultType is DECISION.
 * Null when resultType is missingReport or error.
 *
 * Used by creditPolicy runners to filter out denials from validation checks.
 * Stored in PYTHON_UW_ANALYSIS_INFO for analytics and runner filtering.
 *
 * @TranslateToPython
 */
var UnderwriteMultiSpecsDecisionType;
(function (UnderwriteMultiSpecsDecisionType) {
    /** Application was approved. */
    UnderwriteMultiSpecsDecisionType["approval"] = "approval";
    /** Application was denied. */
    UnderwriteMultiSpecsDecisionType["denial"] = "denial";
})(UnderwriteMultiSpecsDecisionType || (exports.UnderwriteMultiSpecsDecisionType = UnderwriteMultiSpecsDecisionType = {}));
/** @TranslateToPython */
var UwSpecExecutionMode;
(function (UwSpecExecutionMode) {
    UwSpecExecutionMode["SHADOW"] = "shadow";
    UwSpecExecutionMode["MAIN"] = "main";
})(UwSpecExecutionMode || (exports.UwSpecExecutionMode = UwSpecExecutionMode = {}));
